import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
function Footer() {
  return (
    <footer className="py-5">
      <Container>
        <div className="d-flex flex-column flex-sm-row justify-content-between py-2 border-top align-items-center">
          <div>
            <p className="text-muted">© 2025 Boque Quest Services Limited</p>
          </div>
          <Nav className="align-items-center">
            <Nav.Item>
              <Nav.Link href="/terms" className="px-2 text-primary fw-bold">
                TERMS
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="/privacy" className="px-2 text-primary fw-bold">
                PRIVACY
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
